interface DataLayerProps {
    event:string;
    category:DataLayerInteracyionType;
    label:string;
}

export enum DataLayerInteracyionType {
    Button = "Button Interaction",
    Filter = 'Filter Interaction',
    World = 'World Card Interaction',

}
export enum DataLayerActionType {
    Click = "click",

}
export const pushToDataLayer = (dataLayerProps:DataLayerProps) => {
    const {event, category, label} = dataLayerProps;
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event,
        category,
        action: DataLayerActionType.Click,
        label,
      });
    }
  };
  